import React from 'react';
import {Modal, ModalBody, Button} from 'reactstrap';
import PropTypes from 'prop-types';
import { Close } from '@material-ui/icons';
import styles from './AddToCalendarModal.scss';
import { propertyViewTracker } from '../../../lib/tracking';

const generateCalendar = require('calendar-link');

const AddToCalendarModal = (props) => {

  const {
    showModal,
    closeModal,
    property, 
    inspectionTime
  } = props;

  const generateCalendarEvent = (type) => {
    const { listing, address, beds, baths, type: propertyType } = property;
    const { agency, displayPrice } = listing || {};
    const { name: agencyName, agents } = agency || {};
    const agent = agents && agents.length ? agents[0] : {};
    const { name: agentName, email: agentEmail, mobileNumber: agentMobile } = agent || {};

    const evt = {
      title: `Inspection at ${address.shortAddress}`,
      start: inspectionTime.start,
      location: address.formattedAddress || '',
      description: `- Address: ${address.formattedAddress}`
          + `\n- View listing: ${document.URL}`
          + (agency && agent ? `\n- Agent Details: ${agentName} (${agencyName})` : '')
          + (agentMobile ? `, ${agentMobile}` : '')
          + (agentEmail ?`, ${agentEmail}` : '')
          + `\n- Property Price: ${displayPrice}`
          + `\n- Property Type: ${propertyType}`
          + `\n- Beds: ${beds}`
          + `\n- Baths: ${baths}`
          + '\n\nOnTheHouse recommends confirming the inspection time with the listing agent to make sure the date and time of the inspection hasn’t changed.'
    };

    if(inspectionTime.end) {
      evt.end = inspectionTime.end;
    } else {
      evt.duration = [30, 'minutes'];
    }

    propertyViewTracker('add inspection to calendar', property);
    const link = generateCalendar[type](evt);
    window.open(link, '_blank');
  };
  return <Modal isOpen={showModal} toggle={closeModal} className={styles.modalContainer} zIndex={3000}>
    <ModalBody className={styles.modalBody}>
      <h2>Add to calendar</h2>
      <Close className={styles.closeButton}
        onClick={closeModal}/>
      <span>Inspection for {property.address.shortAddress} on <strong>
        {inspectionTime ? inspectionTime.formatted.date : ''} at {inspectionTime ? inspectionTime.formatted.start : ''} - {inspectionTime ? inspectionTime.formatted.end : ''}
      </strong>
      </span>
      <br/>
      <div className={styles.buttonContainer}>
        <Button className={styles.button} outline onClick={() => generateCalendarEvent('google')}>
          <div className={styles.iconContainer}>
            <img className={styles.icon} alt="Google Logo" src="/assets/images/google-logo.svg" />
          </div>
          Google calendar
        </Button>
        <Button className={styles.button} outline onClick={() => generateCalendarEvent('ics')}>
          <div className={styles.iconContainer}>
            <img className={styles.icon} alt="Apple Logo" src="/assets/images/apple-logo.svg" />
          </div>
          Apple calendar
        </Button>
        <Button className={styles.button} outline onClick={() => generateCalendarEvent('outlook')}>
          <div className={styles.iconContainer}>
            <img className={styles.icon} alt="Outlook Logo" src="/assets/images/outlook-logo.png" />
          </div>
          Outlook calendar
        </Button>
        <Button className={styles.button} outline onClick={() => generateCalendarEvent('ics')}>
          <div className={styles.iconContainer}>
            <img className={styles.icon} alt="Add to calendar icon" src="/assets/images/calendar-plus.png" />
          </div>
          Other
        </Button>
      </div>
    </ModalBody>
  </Modal>;
};

AddToCalendarModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  property: PropTypes.object,
  inspectionTime: PropTypes.object
};

export default AddToCalendarModal;
